import { render, staticRenderFns } from "./TwoFactorAuth.vue?vue&type=template&id=dcc8da3e&scoped=true"
import script from "./TwoFactorAuth.vue?vue&type=script&lang=js"
export * from "./TwoFactorAuth.vue?vue&type=script&lang=js"
import style0 from "./TwoFactorAuth.vue?vue&type=style&index=0&id=dcc8da3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcc8da3e",
  null
  
)

export default component.exports